<template>
    <DModal
        :show="showModal"
        :is-awaiting-validation="true"
        :title="__('tools.testing.snapshots.check.modal.title')"
        :message="__('tools.testing.snapshots.check.modal.message', {'snapshot': item})"
        @close="close"
    >
        <div class="modal-content px-4 mb-4">
            <CheckReport
                :results="results"
                :safe-message="__('tools.testing.snapshots.check.modal.no_violations')"
                :unsafe-message="__('tools.testing.snapshots.check.modal.has_violations')"
            />
        </div>
    </DModal>
</template>

<script setup>

import { __ } from '~@/Composables/translation'
import CheckReport from '~@/Components/Tools/Testing/Snapshots/CheckReport.vue'

defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    item: {
        type: String,
        default: ''
    },
    results: {
        type: Array,
        default: () => { return [] }
    }
})

const emit = defineEmits(['close'])

function close () {
    emit('close')
}
</script>

<style lang="scss" scoped>
.modal-content {
    box-shadow: none;
}
</style>
